<template>
  <PmNotificationExternalServiceRequestUpdatedPure
    v-bind="{ ...$attrs, ...props }"
    :is-jump-visible="can('approve', 'requests')"
    :is-request-of-current-user="isRequestOfCurrentUser"
    @open-details="isDetailsVisible = true"
  />

  <portal to="modal">
    <PmModalPure
      v-if="isDetailsVisible"
      title="Antrag Fremddienstleistung"
      @close="isDetailsVisible = false"
    >
      <PmRequestDetail
        v-if="isDetailsVisible"
        :id="props.externalServiceRequestId"
        type="externalServiceRequest"
      />
    </PmModalPure>
  </portal>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useQuery } from '@vue/apollo-composable'

import PmNotificationExternalServiceRequestUpdatedPure, {
  type Props as PropsNotificationExternalServiceRequestCreatedPure,
} from '@/components/PmNotification/PmNotificationExternalServiceRequestUpdated/PmNotificationExternalServiceRequestUpdatedPure.vue'
import PmRequestDetail from '@/components/PmRequestDetail/PmRequestDetail.vue'
import PmModalPure from '@/components/basics/PmModalPure.vue'
import { useAppAbility } from '@/composition/useAppAbility'
import { CurrentUserDocument } from '../../../../generated/graphql'

export interface Props
  extends PropsNotificationExternalServiceRequestCreatedPure {
  externalServiceRequestOfUserId: number
}

const props = withDefaults(defineProps<Props>(), {})

const isDetailsVisible = ref(false)
const { can } = useAppAbility()

const currentUserQuery = useQuery(CurrentUserDocument, null, () => ({
  fetchPolicy: 'cache-first',
}))

const isRequestOfCurrentUser = computed(() => {
  const currentUserId = currentUserQuery.result.value?.user?.id
  if (!currentUserId) return
  return props.externalServiceRequestOfUserId === currentUserId
})
</script>
